// 默认配置
export const oss_url = '//uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official'
export const oss_url_common = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home'

// 环境变量
export const MODE = (() => {
  if (!window) throw new Error('公共头需要在浏览器环境运行')
  // 获取域名
  let host = window.location.hostname
  let isDev = host === 'localhost'
  let mode = 'dev'
  // 是否是生产环境
  let isProd
  host.replace(/app.eline56((dev|test|prepub))?\.com/g, (strMatch, $1, $2, $3) => {
    mode = $2
    isProd = !$3
  })

  if (isDev) {
    return 'development'
  } else if (mode == 'prepub') {
    return 'prepub'
  } else if (isProd) {
    return 'prod'
  } else {
    return mode
  }
})()

export const PROTOCOL = location.protocol
const host = location.host.replace('www', '').replace('app', '')
export const BASEURL = PROTOCOL + '//gateway' + host
export const CPSURL = PROTOCOL + '//cps-server' + host

// 默认打开路径
const activeRules = { user: '/user' }
export const userRule = activeRules.user

// 首页的路径
export const pathOfHome = [
  '/',
  '/about',
  '/industry/list',
  '/introduce/rpa',
  '/introduce/agent',
  '/introduce/grab',
  '/introduce/cps',
  '/introduce/cpsqd',
  '/introduce/vgm',
  '/introduce/afr',
  '/introduce/isf',
  '/introduce/ams',
  '/introduce/ics',
  '/introduce/emAndAci',
  '/introduce/track',
  '/introduce/push',
  '/introduce/shipping',
  '/introduce/apistore',
  '/introduce/four',
  '/introduce/eventsPage'
]

// 不需要登录的 白名单
export const whiteNavs = [...pathOfHome, '/rpaControl', '/rpaControl/rpaStore']

// 业务类型，用于判断公告消息是否显示
export const PRODUCTCODES = {
  // 海外舱单
  em: { pathLogin: '/em', pathNotLogin: '/introduce/emAndAci' },
  aci: { pathLogin: '/aci', pathNotLogin: '/introduce/emAndAci' },
  isf: { pathLogin: '/isf', pathNotLogin: '/introduce/isf' },
  afr: { pathLogin: '/afr', pathNotLogin: '/introduce/afr' },
  ams: { pathLogin: '/ams', pathNotLogin: '/introduce/ams' },
  ics: { pathLogin: '/ics', pathNotLogin: '/introduce/ics' },
  // VGM、上海、青岛舱单
  vgm: { pathLogin: '/vgm', pathNotLogin: '/introduce/vgm' },
  shcps: { pathLogin: '/cps', pathNotLogin: '/introduce/cps' },
  qdcps: { pathLogin: '/cpsqd', pathNotLogin: '/introduce/cpsqd' },
  // 海运跟踪
  shTrack: { pathLogin: '/track', pathNotLogin: '/introduce/track' },
  wholeLink: { pathLogin: '/track', pathNotLogin: '/introduce/track' },
  // 船期查询
  ship: { pathLogin: '/track', pathNotLogin: '/introduce/shipping' },
  // 无忧代理人
  agent: { pathLogin: '/agent', pathNotLogin: '/introduce/agent' },
  // 运价
  freightRate: { pathLogin: '/freight', pathNotLogin: '/freight' }
}

// 枚举：判断是否开通产品的code
export const _ENUM_CODE = {
  VGM: 'vgm',
  SHCPS: 'shcps',
  QDCPS: 'qdcps',
  SHTRACK: 'shTrack',
  SZTRACK: 'szTrack',
  NBTRACK: 'nbTrack',
  SCHEDULE: 'ship',
  CSPPUSH: 'push',
  ICS: 'ics',
  AMS: 'ams',
  EM: 'em',
  ACI: 'aci',
  AFR: 'afr',
  ISF: 'isf',
  AGENT: 'agent',
  ROB: 'rob',
  FREIGHT: 'yjcx'
}

// 子应用的各种配置
export const _ENUM_MICRO = {
  user: {
    code: '',
    bottom: ''
  },
  rpaControl: {
    code: '',
    bottom: ''
  },
  freight: {
    code: '',
    bottom: ''
  },
  em: {
    code: _ENUM_CODE.EM,
    bottom: '/introduce/emAndAci'
  },
  aci: {
    code: _ENUM_CODE.ACI,
    bottom: '/introduce/emAndAci'
  },
  afr: {
    code: _ENUM_CODE.AFR,
    bottom: '/introduce/afr'
  },
  isf: {
    code: _ENUM_CODE.ISF,
    bottom: '/introduce/isf'
  },
  ams: {
    code: _ENUM_CODE.AMS,
    bottom: '/introduce/ams'
  },
  ics: {
    code: _ENUM_CODE.ICS,
    bottom: '/introduce/ics'
  },
  cps: {
    code: _ENUM_CODE.SHCPS,
    bottom: '/introduce/cps'
  },
  cpsqd: {
    code: _ENUM_CODE.QDCPS,
    bottom: '/introduce/cpsqd'
  },
  agent: {
    code: _ENUM_CODE.AGENT,
    bottom: '/introduce/agent'
  },
  grab: {
    code: _ENUM_CODE.ROB,
    bottom: '/introduce/grab'
  },
  track: {
    code: '',
    bottom: '/introduce/track',
    children: {
      'track-sh': {
        code: 'shTrack',
        bottom: '/introduce/track'
      },
      'track-sz': {
        code: 'shTrack',
        bottom: '/introduce/track'
      },
      'track-nb': {
        code: 'shTrack',
        bottom: '/introduce/track'
      },
      schedule: {
        code: 'shTrack',
        bottom: '/introduce/shipping'
      },
      accurate: {
        code: 'shTrack',
        bottom: '/introduce/track'
      },
      route: {
        code: 'shTrack',
        bottom: '/introduce/track'
      },
      fullLink: {
        code: 'wholeLink',
        bottom: '/introduce/track'
      },
    }
  },
  api: {
    code: '',
    bottom: '/introduce/api',
    noCompany: 'not-need'
  },
  vgm: {
    code: _ENUM_CODE.VGM,
    bottom: '/introduce/vgm'
  }
}

// 含有落地页的地址
export const hasBottomUrls = {
  '/agent': {
    login: '/agent',
    notLogin: '/introduce/agent'
  },
  '/grab': {
    login: '/grab',
    notLogin: '/introduce/grab'
  },
  '/em': {
    login: '/em',
    notLogin: '/introduce/emAndAci'
  },
  '/aci': {
    login: '/aci',
    notLogin: '/introduce/emAndAci'
  },
  '/afr': {
    login: '/afr',
    notLogin: '/introduce/afr'
  },
  '/isf': {
    login: '/isf',
    notLogin: '/introduce/isf'
  },
  '/vgm': {
    login: '/vgm',
    notLogin: '/introduce/vgm'
  },
  '/ams': {
    login: '/ams',
    notLogin: '/introduce/ams'
  },
  '/ics': {
    login: '/ics',
    notLogin: '/introduce/ics'
  },
  '/cps': {
    login: '/cps',
    notLogin: '/introduce/cps'
  },
  '/cpsqd': {
    login: '/cpsqd',
    notLogin: '/introduce/cpsqd'
  },
  '/track-sh': {
    login: '/track/track-sh',
    notLogin: '/introduce/track'
  },
  '/track-sz': {
    login: '/track/track-sz',
    notLogin: '/introduce/track'
  },
  '/track-nb': {
    login: '/track/track-nb',
    notLogin: '/introduce/track'
  },
  '/schedule': {
    login: '/track/schedule',
    notLogin: '/introduce/shipping'
  },
  '/accurate': {
    login: '/track/accurate',
    notLogin: '/introduce/shipping'
  },
  '/route': {
    login: '/track/route',
    notLogin: '/introduce/shipping'
  },
  '/fullLink': {
    login: '/track/fullLink',
    notLogin: '/introduce/track'
  },
  '/pushSubscriptions': {
    login: '/track/pushSubscriptions',
    notLogin: '/introduce/push'
  },
  '/api': {
    login: '/apistore/interfaceStore',
    notLogin: '/introduce/apistore'
  }
}
